module.exports = __webpack_public_path__ + "static/mark-0f23c7cbb452e80bd60f2cbebdf6a566.png";